import React, { Component, Fragment } from "react";
import Filter from "../../../manage/Filter";
import _ from "lodash";
import ConfirmButton from "../../../buttons/ConfirmButton";
import { addStepSurvey } from "../../../../redux/actions/surveyActions";
import connect from "react-redux/es/connect/connect";
import RemoveItem from "../../../manage/RemoveItem";

class PDCsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: undefined
    };
  }

  spToLabel(sp = {}) {
    let label = sp.pdc_label || "";
    const adresse = sp.adresse || {};
    const cp = adresse.cp || sp.cp || "";

    if (cp) {
      label += ` (${cp})`;
    }
    return label;
  }

	renderPDCItems() {
		const currentPDCs = this.props.currentPDCs || [];
		const items = [];
		for (let i = 0; i < currentPDCs.length; i++) {
			const currentPDCId = currentPDCs[i];
			const currentPDC = _.find(this.props.pdcs, { pdc_id: currentPDCId });
			if (!currentPDC) continue;
			const label = this.spToLabel(currentPDC);
			items.push(
				<RemoveItem
					key={i}
					label={label}
					onClick={() => {
						const surveyProgress = this.props.surveyProgress || [];
						surveyProgress.pdcs = surveyProgress.pdcs || [];
						//use pdcs to get survey visibility
						surveyProgress.usePdcs = true;
						const index = surveyProgress.pdcs.indexOf(currentPDCId);
						if (index !== -1) surveyProgress.pdcs.splice(index, 1);
						surveyProgress.pdcs = [...surveyProgress.pdcs];

						if(surveyProgress.pdcs.length === 0){
							surveyProgress.usePdcs = false;
						}

						this.props.addStepSurvey(surveyProgress);
					}}
				/>,
			);
		}

		return items;
	}

	addPDC() {
		const value = this.filter.getValue();
		if (!value) return;
		this.filter.reset();

		const surveyProgress = this.props.surveyProgress;
		surveyProgress.pdcs = surveyProgress.pdcs || [];
		//use pdcs to get survey visibility
		surveyProgress.usePdcs = true;
		if (surveyProgress.pdcs.indexOf(value) === -1) {
			console.log("add ", value);
			surveyProgress.pdcs = [...surveyProgress.pdcs, value];
		} else {
			console.log("already present");
		}
		this.props.addStepSurvey(surveyProgress);
	}

  render() {
    return (
      <Fragment>
        <div className="p-mrg-top p-al-left">
          <Filter
            ref={elt => {
              this.filter = elt;
            }}
            match={(searchValue = "", element = {}) => {
              const currentElements = this.props.currentPDCs || [];
              const formattedElement = this.spToLabel(element);

              return (
                currentElements.indexOf(element.pdc_id) === -1 &&
                formattedElement.toUpperCase().indexOf(searchValue.toUpperCase()) !== -1
              );
            }}
            elements={this.props.availablesPDCs}
            currentElements={this.props.currentPDCs}
            elementKey={"pdc_id"}
            onSelect={v => {
              this.setState({ value: v }, () => {
                //this.addPDC();
              });
            }}
            format={v => {
              return this.spToLabel(v);
            }}
            selectProps={{
              placeholder: "Recherchez un PDC",
              notFoundContent: "Aucun PDC disponible",
              style: { width: "70%" }
            }}
            nbItems={100}
          />

          <ConfirmButton label={"Ajouter"} large={true} classes={"p-mrg-left"} onClick={() => this.addPDC()} />
        </div>
        <div style={{ maxHeight: "40vh", overflowY: "auto", paddingRight: 20 }}>{this.renderPDCItems()}</div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const surveyProgress = state.survey.surveyManager.surveyProgress || {};
  const models = surveyProgress.model || [];
  let model = models.length > 0 ? models[0] : {};
  const retailerId = model.idRetailer || "";
  const pdcs = state.sectors.pdcs || [];
  const availablesPDCs = [];

  for (let i = 0; i < pdcs.length; i++) {
    const pdc = pdcs[i] || {};
    if (pdc.retailer_id === retailerId) {
      availablesPDCs.push(pdc);
    }
  }

  return {
    surveyProgress: state.survey.surveyManager.surveyProgress,
    sectorList: state.survey.surveyManager.sectorList,
    availablesPDCs: availablesPDCs,
    pdcs: state.sectors.pdcs || [],
    currentPDCs: state.survey.surveyManager.surveyProgress.pdcs || []
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addStepSurvey: survey => {
      dispatch(addStepSurvey(survey));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PDCsView);



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepSecteur/PDCsView.js